import AddIcon from '@mui/icons-material/Add';
import { Grid, Box } from '@mui/material';
import { isEmpty } from 'lodash-es';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getJobBoardByJBName, IJobBoardDTO } from 'wisestep-api';
import { WsButton, WsTypoColors, WsTypography, WsTypoVariants } from 'wisestep-base';

import {
  useNativeSearchAccessControl,
  NativeSearchAction,
} from '../../../../../hooks/useNativeSearchAccessControl';
import CareerBuilder from '../../../../../images/jobBoardsIcons/CareerBuilder.png';
import NativeSearchSettings from '../../../NativeSearchSettings';
import AccountList from '../../nativeSearchIndex/AccountsList';
import SearchSharedUser from '../../searchSharedUser/SearchSharedUser';
import { NativeDialogHeader } from '../dice/DiceNewAccount';

const CareerBuilderRDBAdd = () => {
  const navigate = useNavigate();
  const { access, owns } = useNativeSearchAccessControl([
    NativeSearchAction.MANAGE_NATIVE_SEARCH_ACCOUNTS,
  ]);
  const [manage] = access;
  const [configuredAcc, setConfiguredAcc] = useState<IJobBoardDTO[]>([]);
  useEffect(() => {
    const fetchJobBoardAcc = async () => {
      const response = await getJobBoardByJBName('CAREER_BUILDER');
      if (response.data) setConfiguredAcc(response.data);
    };
    fetchJobBoardAcc();
  }, []);
  const getLatest = async () => {
    const response = await getJobBoardByJBName('CAREER_BUILDER');
    if (response.data) setConfiguredAcc(response.data);
  };
  return (
    <NativeSearchSettings>
      <Box borderRadius={1.5}>
        <NativeDialogHeader>
          <Grid container>
            <Grid item container xs={10} columnGap={2}>
              <img src={CareerBuilder} alt="CareerBuilder" height="35" />
              <WsTypography variant={WsTypoVariants.SUB_TITLE} color={WsTypoColors.BLACK}>
                Career Builder RDB
              </WsTypography>
            </Grid>
            {(owns || manage) && (
              <Grid item xs={2} container justifyContent="flex-end">
                <WsButton
                  startIcon={<AddIcon fontSize="small" />}
                  onClick={() => navigate('/native-search-settings/cb-rdb-add')}
                >
                  Add account
                </WsButton>
              </Grid>
            )}
          </Grid>
        </NativeDialogHeader>
        <SearchSharedUser setAccounts={setConfiguredAcc} jobBoardName="CAREER_BUILDER" />
        {configuredAcc && !isEmpty(configuredAcc) ? (
          <Grid container>
            <Grid item xs={12}>
              <AccountList
                latestData={getLatest}
                accountType={'CAREER_BUILDER'}
                tableData={configuredAcc}
                dataUpdater={(data) => setConfiguredAcc(data)}
              />
            </Grid>
          </Grid>
        ) : (
          <Box bgcolor="white">
            <Grid container p={4} rowGap={3}>
              <Grid item xs={12}>
                <WsTypography>
                  There are no accounts set up for Career Builder RDB Job Board. Configure your
                  Career Builder RDB account using search credentials
                </WsTypography>
              </Grid>
              {(owns || manage) && (
                <Grid item xs={12}>
                  <WsButton
                    startIcon={<AddIcon fontSize="small" />}
                    size="large"
                    onClick={() => navigate('/native-search-settings/cb-rdb-add')}
                  >
                    Add account
                  </WsButton>
                </Grid>
              )}
            </Grid>
          </Box>
        )}
      </Box>
    </NativeSearchSettings>
  );
};

export default CareerBuilderRDBAdd;
